import { createFileRoute } from "@tanstack/react-router"

import { VehiclesIndexRouteComponent } from "@/routes/_authenticated/account/vehicles/index"

export const Route = createFileRoute(
  "/qr/$qrLookupID/_authenticated/account/vehicles/"
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <VehiclesIndexRouteComponent />
}
